
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"47","height":"47","viewBox":"0 0 47 47","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"23.5","cy":"23.5","r":"23","stroke":"#4D4D4F"}}),_c('path',{attrs:{"d":"M30 20C30 18.4087 29.3679 16.8826 28.2426 15.7574C27.1174 14.6321 25.5913 14 24 14C22.4087 14 20.8826 14.6321 19.7574 15.7574C18.6321 16.8826 18 18.4087 18 20C18 27 15 29 15 29H33C33 29 30 27 30 20Z","stroke":"#4D4D4F","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M25.7295 33C25.5537 33.3031 25.3014 33.5547 24.9978 33.7295C24.6941 33.9044 24.3499 33.9965 23.9995 33.9965C23.6492 33.9965 23.3049 33.9044 23.0013 33.7295C22.6977 33.5547 22.4453 33.3031 22.2695 33","stroke":"black","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    